module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": _vm.href
    }
  }, [_c('span', {
    staticClass: "href-text-ui",
    style: (_vm.style)
  }, [_vm._t("default"), _vm._v(" "), (_vm.arrow) ? _c('img', {
    staticClass: "arrow-next",
    attrs: {
      "src": "/static/img/next-controll.svg"
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb93ba56","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/UITextHref.vue
// module id = 378
// module chunks = 2